export default __webpack_public_path__ + "static/media/NIO.c509806b.png";